import { render, staticRenderFns } from "./ClientManageDetail.vue?vue&type=template&id=e58870ec&"
import script from "./ClientManageDetail.vue?vue&type=script&lang=js&"
export * from "./ClientManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientManageDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports